import React from 'react';

import { DndProvider } from "react-dnd";
import { HTML5Backend } from 'react-dnd-html5-backend';

import UserRoutes from './routes/index';

import './styles/global.scss';
import 'antd/dist/antd.css';

const App = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <UserRoutes />
      </div>
    </DndProvider>
  )
}

export default App;